import { createBaseThemeVariation } from './base';
export const KindredTheme = createBaseThemeVariation({
    name: 'kindred',
    brandColor: 'hsla(185, 100%, 30%, 1)',
    primaryColors: {
        p50: 'hsla(185, 100%, 98%, 1)',
        p75: 'hsla(185, 100%, 97%, 1)',
        p100: 'hsla(185, 100%, 96%, 1)',
        p200: 'hsla(185, 100%, 90%, 1)',
        p300: 'hsla(185, 100%, 70%, 1)',
        p400: 'hsla(185, 100%, 30%, 1)',
        p500: 'hsla(185, 100%, 15%, 1)',
    },
});
